import { useEffect } from "react";
import DialogBox from "../../../components/UI/DialogBox";
import { handleErrMessage } from "../../../functions/handleErrMessage";
import MainPageLayout from "../../../layout/MainPageLayout";
import spin from "../../../assets/icons/spin.png";
import useGetData from "../../../CustomHooks/useAxios/useGetData";
import { JOBCARD_REPORT_OPTION } from "../components/apiEndpoints";
import JobCardReportManager from "../components/Jobcard-report/JobCardReportManager";

const JobCardReportPage = () => {
  const { data, isLoaded, error, getData } = useGetData();

  useEffect(() => {
    getData(JOBCARD_REPORT_OPTION);
  }, []);

  return (
    <MainPageLayout
      headerConfig={{ title: "Job Card Report" }}
      bgColor="bg-dBlue-100"
    >
      {isLoaded && !error ? (
        <JobCardReportManager checkpointNames={data} />
      ) : error ? (
        <DialogBox
          title="Error"
          message={handleErrMessage(error)}
          isErrorHandleButtons={true}
        />
      ) : (
        <DialogBox message="Loading..." animateIcon={spin} />
      )}
    </MainPageLayout>
  );
};

export default JobCardReportPage;
